import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
import { PesIcon, PdpIconTooltip } from '@pes-ui/components-react';
import { ExtraMenu } from '../../../ExtraMenu/ExtraMenu.jsx';
import { copyTextToClipboard } from '../../../../common/helpers/copyToClipboard.js';
import { DeleteIcon } from '../../SingleItem/DeleteIcon/DeleteIcon.jsx';
import { EditableConfiguration } from '../EditConfiguration/EditConfiguration.jsx';
import { exportPaths, exportType } from '../../../../constants/constants';
import { handleDownload } from '../../../../utils/saveFile';
import { fromUrl, createUrl } from '../../../../utils/utils';
import { Brand } from '../../../../utils/types';

class _ExtraGroupMenu extends Component {
  constructor(props) {
    super(props);
    this.copyToClipboardElement = !!props.item.codification && (
      <div className="cart-group__extra-row" onClick={this.execCopyToClipboard}>
        <PesIcon class="actions-block__cta-icon" size={pesIconSizes.SMALL}>
          action_duplicate
        </PesIcon>
        <span className="actions-block__cta pes-link">{props.labelsStore.configurationId}</span>
      </div>
    );

    this.exportXML = !!props.item.hiveId && (
      <div className="cart-group__extra-row">
        <PesIcon class="actions-block__cta-icon" size={pesIconSizes.SMALL}>
          file_xml
        </PesIcon>
        <span className="actions-block__cta pes-link" onClick={this.onExportXML}>
          {props.labelsStore.exportXml}
        </span>

        <PdpIconTooltip
          class="indent-words--this"
          icon="information_circle"
          iconSize={pesIconSizes.MICRO}
          iconColor="blue"
          position="top"
          >
          {props.labelsStore.xmlTooltip}
        </PdpIconTooltip>
      </div>
    );
  }

  /* data-stayopen */
  execCopyToClipboard = async () => {
    try {
      const { codification, showClipboardNotify } = this.props.item;
      await copyTextToClipboard(codification);
      requestAnimationFrame(showClipboardNotify); 
    } catch (error) {
      console.error('Error copying to clipboard:', error);
    }
  };

  onExportXML = () => {
    const { documentsStore, item } = this.props;
    const { hiveId, name  } = item;
    const { countryCode, languageCode } = documentsStore.documentsAPI;
    const url = createUrl({
      endpoint: exportPaths[exportType.MY_PRODUCTS_XML].path,
      queryParams: {
        'country-code':countryCode,
        'language-code':languageCode,
        brand: Brand.SE_BRAND,
        hiveId,
      }
    });
    handleDownload(url, `${name}.xml`);
  };

  remove = () => {
    this.props.item.remove({ withoutConfirm: true });
  };

  render() {
    const { uiStore, labelsStore, item } = this.props;
    const hasEditConfiguraton = !!item.backURL || !!item.codification;
    const shouldShowEdit = hasEditConfiguraton && (this.props.uiStore.isMiddleRes || this.props.uiStore.isMobile);
    const editConfiguration = shouldShowEdit
      && (
        <div className="cart-group__extra-row">
          <EditableConfiguration item={this.props.item} />
        </div>
      );

    if (!editConfiguration && !this.copyToClipboardElement && !this.exportXML) {
      return uiStore.isMobile ? <DeleteIcon onClickHandler={this.remove} /> : null;
    }

    // TODO: make refactoring due to uncleared action's behaviour
    if (!uiStore.isMobile && (!!this.copyToClipboardElement + !!this.exportXML === 1)) {
      if (!uiStore.isMiddleRes || (uiStore.isMiddleRes && !editConfiguration)) {
        return this.copyToClipboardElement || this.exportXML;
      }
    }

    return (
      <div className={this.props.containerClasses}>
        <ExtraMenu ID={item.ID}>

          <div className="cart-group__extra">

            {editConfiguration}

            {this.exportXML}

            {this.copyToClipboardElement}

            {uiStore.isMobile
            && (
              <div className="cart-group__extra-row">
                <DeleteIcon onClickHandler={this.remove} label={labelsStore.removeLabel} />
              </div>
            )}

          </div>
        </ExtraMenu>
      </div>
    );
  }
}

_ExtraGroupMenu.propTypes = {
  item: propTypes.shape({
    ID: propTypes.string.isRequired,
    configurationMasterId: propTypes.string,
    remove: propTypes.func,
    showClipboardNotify: propTypes.func,
    codification: propTypes.string,
    backURL: propTypes.string,
    hiveId: propTypes.string,
    name: propTypes.string
  }).isRequired,

  uiStore: propTypes.shape({
    isMobile: propTypes.bool,
    isMiddleRes: propTypes.bool
  }).isRequired,

  labelsStore: propTypes.shape({
    configurationId: propTypes.string,
    removeLabel: propTypes.string,
    xmlTooltip: propTypes.string,
    exportXml: propTypes.string,
  }).isRequired,
  documentsStore: propTypes.shape({
    documentsAPI: propTypes.object.isRequired,
  }).isRequired,
  containerClasses: propTypes.string.isRequired
};

export const ExtraGroupMenu = inject('labelsStore', 'uiStore', 'documentsStore')(observer(_ExtraGroupMenu));
